// extracted by mini-css-extract-plugin
module.exports = {"root":"price-helptext_root__IFUGR","sizelg":"price-helptext_sizelg__3ypef"};